import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import RoleSaga from "./role/saga"
import DocumentSaga from "./document/saga"
import UserSaga from "./user/saga"
import NotificationSaga from "./notification/saga"
import NavigationSaga from "./navigation/saga"
import CenterProfileSaga from "./profile/saga"
import reportSaga from "./report/saga"
import dashboardSaga from "./dashboard/saga"
import userSaga from "./user/saga"
import calendarSaga from "./calendar/saga"
import moduleSaga from "./module/saga"
import helperSaga from "./helper/saga"
import subscriptionSaga from "./subscription/saga"
import zoomSaga from "./zoom/saga"
import projectSaga from "./project/saga"
import householdSaga from "./household/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(RoleSaga),
    fork(DocumentSaga),
    fork(UserSaga),
    fork(NotificationSaga),
    fork(NavigationSaga),
    fork(CenterProfileSaga),
    fork(reportSaga),
    fork(dashboardSaga),
    fork(userSaga),
    fork(calendarSaga),
    fork(moduleSaga),
    fork(helperSaga),
    fork(subscriptionSaga),
    fork(zoomSaga),
    fork(projectSaga),
    fork(householdSaga),
  ])
}
